<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="year" label="年度">
        <el-date-picker
          v-model="searchModel.year"
          type="year"
          placeholder="请选择"
          value-format="yyyy"
          format="yyyy"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item prop="keyword" label="工程名称">
        <el-input
          v-model="searchModel.keyword"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="reportCode" label="委托编号">
        <el-input
          v-model="searchModel.reportCode"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item v-show="!collapsed" prop="etmtType" label="工程类型">
        <el-select v-model="searchModel.etmtType" clearable placeholder="请选择" @change="getTableData(true)">
          <el-option v-for="item in etmtTypeOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="!collapsed" prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label-width="0" class="form-btn">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button type="text" class="search-isOpen" @click="collapsed = !collapsed">
          {{ collapsed ? '展开' : '收起' }}
          <i class="el-icon--right" :class="collapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
        </el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" storageKey="hiddenColumns_meterialTesting" @onRefresh="getTableData()">
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50" fixed>
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="reportCode" label="委托编号" width="140" align="center"></el-table-column>
        <el-table-column prop="client" label="委托单位" align="center"></el-table-column>
        <el-table-column prop="sfcn" label="委托人" align="center"></el-table-column>
        <el-table-column prop="projectName" label="工程名称" align="center"></el-table-column>
        <el-table-column prop="etmtTypeText" label="工程类型" align="center"></el-table-column>
        <el-table-column prop="testTypeText" label="检测类型" align="center"></el-table-column>
        <el-table-column prop="state" label="状态" align="center">
          <template v-slot="{ row }">
            <el-tag v-if="row.state == 0" type="info">待提交</el-tag>
            <el-tag v-if="row.state == 7" type="primary">待审核</el-tag>
            <el-tag v-if="row.state == 8" type="success">待批准</el-tag>
            <el-tag v-if="row.state == -8" type="danger">审核驳回</el-tag>
            <el-tag v-if="row.state == 9" type="success">批准通过</el-tag>
            <el-tag v-if="row.state == -9" type="danger">批准驳回</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="退回原因" align="center"></el-table-column>
        <el-table-column prop="createtime" label="创建时间" align="center"></el-table-column>
        <el-table-column prop="createByName" label="创建人" align="center" width="100"></el-table-column>

        <el-table-column label="操作" width="180" align="center">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleDetail(row)">详情</el-link>
            <el-link type="primary" @click="handleEdit(row)">编辑</el-link>
            <div>
              <el-popover class="button-popper" placement="left" width="300" trigger="click">
                <el-button
                  v-for="model in row.modelList"
                  :key="model.modelCode"
                  type="primary"
                  @click="handlePreviewOridata(row, model.modelCode)"
                >
                  {{ model.testItem }}
                </el-button>
                <el-link slot="reference" type="primary">原始记录</el-link>
              </el-popover>

              <el-link type="primary" @click="handlePreviewReport(row, 0)">检测报告</el-link>

              <br />
              <el-link type="primary" @click="handlePreviewReport(row, 1)">检测报告(不合格)</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 新增/编辑 -->
    <MeterialEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getTableData()"></MeterialEdit>
    <!-- 详情 -->
    <MeterialDetail :visible.sync="detailVisible" :activeId="activeRowId"></MeterialDetail>
    <!-- 填写原始记录 -->
    <DataWrite :visible.sync="writeVisible" :activeInfo="activeInfo"></DataWrite>
    <!-- 填写原始记录 -->
    <DataWriteBD :visible.sync="writeBdzVisible" :activeInfo="activeInfo"></DataWriteBD>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { getToken } from '@/utils/auth';

import TableHeader from '@/components/TableHeader';
import MeterialEdit from './components/MeterialEdit';
import MeterialDetail from './components/MeterialDetail';
import DataWrite from './components/DataWrite';
import DataWriteBD from './components/DataWriteBD';

import { getDictsByCode } from '@/api/system';
import { getTotEntrustmentList, deleteTotEntrustment } from '@/api/entrust';
import { editTotEntrustmentState, getTotEntrustmentCountByUser } from '@/api/flow';

export default {
  components: { TableHeader, MeterialEdit, MeterialDetail, DataWrite, DataWriteBD },
  data() {
    return {
      collapsed: true,
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        year: moment().format('YYYY'),
        reportCode: '',
        keyword: '',
        etmtType: '',
        dateRange: []
      },
      etmtTypeOptions: [],
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      tableSelection: [],
      // 弹窗
      activeRowId: null,
      activeInfo: {},
      activeClient: '',
      detailVisible: false,
      editVisible: false,
      writeVisible: false,
      writeBdzVisible: false
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {},
  filters: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getTotEntrustmentList({ ...this.searchModel, startTime, endTime });
      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    // 详情
    handleDetail(row) {
      this.activeRowId = row.id;
      this.detailVisible = true;
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleWrite(row) {
      this.activeInfo = row;

      if (row.etmtType == 'petmt_type_xl') {
        this.writeVisible = true;
      } else {
        this.writeBdzVisible = true;
      }
    },
    async handleSubmit(row) {
      this.$confirm('确定提交审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await editTotEntrustmentState({ id: row.id, state: 7 });
        this.$message.success('提交成功！');
        this.getTableData();
      });
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteTotEntrustment({ ids: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    },
    handlePreviewOridata(row, modelCode) {
      const params = JSON.stringify({
        token: getToken(),
        wordType: 'siteOridata',
        modelCode,
        entrustmentId: row.id
      });
      // eslint-disable-next-line no-undef
      POBrowser.openWindow('pageOffice/oriData', 'width=1200px;height=800px;', params);
    },
    handlePreviewReport(row, ft) {
      const params = JSON.stringify({
        token: getToken(),
        wordType: 'siteReport',
        entrustmentId: row.id,
        ft
      });
      // eslint-disable-next-line no-undef
      POBrowser.openWindow('pageOffice/report', 'width=1200px;height=800px;', params);
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data ?? [];
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
    this.getDictsByCode('petmt_type', 'etmtTypeOptions');
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
.button-popper {
  margin: 0 10px;
}
</style>
